module.exports = __webpack_public_path__ + "img/60f8.0b6b0418.jpg";